// AI Generated Test
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonModalService } from 'app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'form-global-policy-content',
    templateUrl: './content.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormGlobalPolicyContentComponent implements OnInit {
    @Input() policy: any;
    @Output() wizNext = new EventEmitter<void>();

    currentSubject: string = '';
    checkingAffections = false;

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private monModalService: MonModalService,
        private translateService: TranslateService,
    ) {}

    ngOnInit () {
        this.currentSubject = this.policy.subject || '';
        this.policy.subject = this.currentSubject;
    }

    checkChange (subject: string) {
        if (this.checkingAffections) {
            return;
        }
        this.currentSubject = subject;
        if (this.policy.subject === '') {
            this.policy.subject = this.currentSubject;
            this.onWizNext();
        } else {
            this.checkAffections();
        }
    }

    checkAffections () {
        this.policyFormHelperService.setPolicySubject(this.currentSubject);

        const ruleOptions = this.policyFormHelperService.getSubjectTypeOptions();
        const rulesToBeRemoved = this.policy.rules.filter((rule: any) => {
            return !ruleOptions.find((option: any) => {
                return option.type === rule.type;
            });
        });

        if (rulesToBeRemoved.length > 0) {
            this.policyFormHelperService.setPolicySubject(this.policy.subject);
            this.monModalService.confirm(this.generateConfirmMessage(this.policyFormHelperService.getSubjectTypeOptions(), rulesToBeRemoved)).then(
                () => {
                    this.checkingAffections = false;
                    this.policy.subject = this.currentSubject;
                    this.onWizNext();
                },
                () => {
                    this.checkingAffections = false;
                    this.policyFormHelperService.setPolicySubject(this.policy.subject);
                },
            );
            this.checkingAffections = true;
        } else {
            this.policy.subject = this.currentSubject;
            this.onWizNext();
        }
    }

    generateConfirmMessage (rules: any[], rulesToBeRemoved: any[]): string {
        let message =
            '<strong>' +
            this.translateService.getString('The following rules will be removed, are you sure you want to continue with this change?') +
            '</strong>\n<br/><br/>';

        rulesToBeRemoved.forEach((rule: any) => {
            message +=
                '<div class="text-link policy-form-content">' +
                '<div class="d-flex align-items-center my-3 rules-fixed-height-container mb-2">' +
                '<div class="pr-3 icon-container">';

            this.getRule(rules, rule.type).icons.forEach((icon: string) => {
                message += '<span class="' + icon + ' fa-2x outer-r-mini inline-block"></span>';
            });

            message +=
                '</div>' +
                '<div class="text-left">' +
                this.translateService.getString('Rule') +
                ': ' +
                (rule.name || this.translateService.getString('No name defined')) +
                '</div>' +
                '</div>' +
                '</div>';
        });
        return message;
    }

    getRule (rules: any[], ruleType: string): any {
        return (
            rules.find((rule: any) => {
                return rule.type === ruleType;
            }) || { icons: [] }
        );
    }

    onWizNext () {
        this.wizNext.emit();
    }
}
